module.exports = __webpack_public_path__ + "0a3be392.gif";